export enum LoginErrorCode {
  UserNameOrPasswordAreEmpty = 100,
  WrongUserNameFormat = 101,
  NoUser = 102,
  UserNotActive = 103,
  WrongPassword = 104,
  UserLocked = 105,
  ProjectInactive = 106,
  UserNotInvited = 107
}
